import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-238a7f08")

_pushScopeId("data-v-238a7f08")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-9" }
const _hoisted_3 = { class: "shadow-box p-shadow-1" }
const _hoisted_4 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_5 = { class: "shadow-box p-shadow-1" }
const _hoisted_6 = {
  class: "metadata",
  style: {"padding":"1rem","border-radius":"14px"}
}
const _hoisted_7 = { class: "p-d-flex p-flex-column" }
const _hoisted_8 = { class: "p-text-light p-ml-2" }
const _hoisted_9 = { class: "p-d-flex p-ai-center" }
const _hoisted_10 = { class: "p-pl-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatasourcesList = _resolveComponent("DatasourcesList")!
  const _component_DsMetadata = _resolveComponent("DsMetadata")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ScrollTop = _resolveComponent("ScrollTop")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DatasourcesList, {
          onClickRow: _ctx.onListDatasourceClickRow,
          onSelectDatasource: _ctx.onSelectDatasource,
          workspaceId: _ctx.workspaceId
        }, null, 8, ["onClickRow", "onSelectDatasource", "workspaceId"])
      ])
    ]),
    (_ctx.isDataSourceSelected)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_DsMetadata, {
              datasourceDetail: _ctx.selectedDataSource,
              workspaceId: _ctx.workspaceId
            }, null, 8, ["datasourceDetail", "workspaceId"]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("autots.create.header.information")), 1),
                _createVNode(_component_ScrollPanel, {
                  style: {"height":"55vh"},
                  class: "custombar1"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_DataTable, {
                      value: _ctx.selectedDataSource.schemas,
                      class: "p-datatable-sm"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_Column, {
                          headerStyle: "display: none;",
                          bodyClass: "metadata",
                          bodyStyle: "border: 0;"
                        }, {
                          body: _withId((slotProps) => [
                            _createVNode("div", _hoisted_9, [
                              _createVNode(_component_DataType, {
                                dataType: slotProps.data.type
                              }, null, 8, ["dataType"]),
                              _createVNode("div", _hoisted_10, _toDisplayString(slotProps.data.name), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_ScrollTop, {
                      target: "parent",
                      threshold: 100,
                      class: "custom-scrolltop",
                      icon: "pi pi-arrow-up"
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})